import SolidsControl from './SolidsControl';

export default SolidsControl;



// WEBPACK FOOTER //
// ./src/Components/Main/TestWorkflow/FluidData/SolidsControl/index.tsx